<template>
  <div class="wrapper">
    <div class="wrapp">
      <div v-if="loading" class="row">
        <div class="col-12">
          <div class="text-center text-primary my-2">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </div>
      </div>
      <div v-else-if="error" class="row">
        <div class="col-12">
          <go-back-button />
        </div>
      </div>
      <div v-else class="row">
        <div class="divButton">
          <b-button @click="exportPdfTreatments" title="Exportar" class="export-pdf-treatments"><i class="fas fa-file-pdf"
              style="font-size: 1em;"></i></b-button>
          <template>
            <b-dropdown id="ddd" no-caret :title="`${this.$t('treatments.options')}`" class="transfer-treatments"
              v-if="userProfile.permissions.trash.menu">
              <template slot="button-content">
                <font-awesome-icon id="btn-transfer" icon="cog" />
              </template>
              <template v-if="this.userAuth.companyId === '5e18ccd0dc36a60022491bdf' ||
                this.userAuth.companyId === '61965aa04be7ea63c8f83435'
                ">
                <b-dropdown-item id="btnDrop" @click="transferMercedez" :title="`${this.$t('treatments.options')}`">
                  {{ $t('answers.answersDetails.transferFactoryAccount') }}
                </b-dropdown-item>
              </template>
              <!-- Transfer of research between actions - Sinqia -->
              <b-dropdown-item v-if="(this.userAuth.companyId === '61df3295564a28779efa96ef' &&
                this.userProfile.type === 'admin') ||
                (this.userAuth.companyId === '615e1e84f3614a0cdde347a5' &&
                  this.userProfile.type === 'admin') ||
                (this.userAuth.companyId === '615e1d7edda6910cf7f30a12' &&
                  this.userProfile.type === 'admin') ||
                (this.userAuth.companyId === '611cf4a2b072b92103fb492c' &&
                  this.userProfile.type === 'admin') ||
                (this.userAuth.companyId === '6297c40f712fe00681e48354' &&
                  this.userProfile.type === 'admin') ||
                this.userAuth.companyId === '5d8ba15696fa442270173557' ||
                (this.userAuth.companyId === '61fc1c9ed079433bc4a20435' &&
                  this.userProfile.type === 'admin') ||
                (this.userAuth.companyId === '64c15b2635d4e400201540d3' &&
                  this.userProfile.type === 'admin') ||
                  (this.userAuth.companyId === '63b70ed581f28d001a272dac' &&
                  this.userProfile.type === 'admin') ||
                (this.userAuth.companyId === '63b7101381f28d001a2748bb' &&
                  this.userProfile.type === 'admin')
                " class="btn-research">
                <b-button v-b-modal.research-action @click="getActions" style="background: #fff; border: 0; padding: 0;">
                  <span>{{
                    $t('answers.answersDetails.transferBetweenShares')
                  }}</span></b-button>

                <b-modal id="research-action" size="lg" :title="`${$t(
                      'answers.answersDetails.transferBetweenShares',
                    )}`" @ok="transferAction">
                  <p>
                    {{ $t('answers.answersDetails.actionDescription') }}
                  </p>
                  <div style="display: flex;">
                    <input type="text" class="form-control" style="width: 300px;"
                      :placeholder="`${$t('answers.answersDetails.search')}`" v-model="filterAction"
                      @keyup="handleFilterAction" />
                    <button class="btn btn-outline-primary" @click="cleanFilter('action')"
                      :title="`${$t('menu.settings.users.clear')}`">
                      {{ $t('menu.settings.users.clear') }}
                    </button>
                  </div>
                  <div>
                    <b-table striped :items="allActions.data" :fields="fieldsAction" :busy="loadingBranches" responsive
                      class="mt-4">
                      <template v-slot:table-busy>
                        <div class="text-center text-primary my-2">
                          <b-spinner type="grow" class="align-middle"></b-spinner>
                        </div>
                      </template>
                      <template v-slot:cell(createdAt)="row">
                        <p>
                          {{
                            row.item.createdAt
                            ? formatDate(row.item.createdAt)
                            : '-'
                          }}
                        </p>
                      </template>
                      <template v-slot:cell(options)="row">
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-radio style="margin-left: 20px;" v-model="idAction" :aria-describedby="ariaDescribedby"
                            :value="row.item._id"></b-form-radio>
                        </b-form-group>
                      </template>
                    </b-table>
                    <div class="pagination-area-edit-rule mt-1">
                      <paginate v-model="pageAction" :pageCount="Math.ceil(totalAction / this.limit)"
                        :clickHandler="getActions" :prevText="'‹'" :nextText="'›'" :activeClass="'active'"
                        :containerClass="'pagination b-pagination'" :pageClass="'page-item'"></paginate>
                    </div>
                  </div>
                </b-modal>
              </b-dropdown-item>
              <!-- - -->
              <b-dropdown-item v-if="this.userAuth.companyId !== '611cf4a2b072b92103fb492c'" class="btn-research">
                <b-button v-b-modal.research-branch style="background: #fff; border: 0; padding: 0;">
                  <span>{{
                    $t('answers.answersDetails.transferAffiliateSearch')
                  }}</span></b-button>

                <b-modal id="research-branch" size="lg" :title="`${$t(
                      'answers.answersDetails.transferAffiliateSearch',
                    )}`" @ok="transfer">
                  <p>
                    {{ $t('answers.answersDetails.branchSearchDescription') }}
                  </p>
                  <div style="display: flex;">
                    <input type="text" class="form-control" style="width: 300px;"
                      :placeholder="`${$t('answers.answersDetails.search')}`" v-model="filter" @keyup="handleFilter" />

                    <button class="btn btn-outline-primary" @click="cleanFilter"
                      :title="`${$t('menu.settings.users.clear')}`">
                      {{ $t('menu.settings.users.clear') }}
                    </button>
                  </div>
                  <div>
                    <b-table striped :items="ih1.branches" :fields="fields" :busy="loadingBranches" responsive
                      class="mt-4">
                      <template v-slot:table-busy>
                        <div class="text-center text-primary my-2">
                          <b-spinner type="grow" class="align-middle"></b-spinner>
                        </div>
                      </template>
                      <template v-slot:cell(createdAt)="row">
                        <p>
                          {{
                            row.item.createdAt
                            ? formatDate(row.item.createdAt)
                            : '-'
                          }}
                        </p>
                      </template>
                      <template v-slot:cell(options)="row">
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-radio style="margin-left: 20px;" v-model="idBranch" :aria-describedby="ariaDescribedby"
                            :value="row.item._id"></b-form-radio>
                        </b-form-group>
                      </template>
                    </b-table>
                    <div class="pagination-area-edit-rule mt-1">
                      <paginate v-model="page" :pageCount="Math.ceil(ih1.total / this.limit)" :clickHandler="getBranches"
                        :prevText="'‹'" :nextText="'›'" :activeClass="'active'"
                        :containerClass="'pagination b-pagination'" :pageClass="'page-item'"></paginate>
                    </div>
                  </div>
                </b-modal>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </div>
        <div class="col-12" id="main-treatments">
          <div style="margin-top: -98px;">
            <span class="header-icon">
              <font-awesome-icon :icon="['fas', 'info-circle']" />
            </span>
            <h2>
              {{ $t('answers.answersDetails.details') }}
            </h2>
          </div>

          <!-- Dados da Ação -->
          <div class="mt-5" v-b-toggle.collapse-1 style="cursor: pointer;">
            <span class="when-opened menu-icons">
              <font-awesome-icon :icon="['fas', 'angle-double-down']" />
            </span>
            <span class="when-closed menu-icons">
              <font-awesome-icon :icon="['fas', 'angle-double-right']" />
            </span>
            <h3>{{ $t('answers.answersDetails.treatments.dataAction') }}</h3>
            <hr />
          </div>
          <b-collapse id="collapse-1" class="mt-2" visible>
            <ActionData />
          </b-collapse>

          <!-- <b-collapse id="collapse-2" class="mt-2" visible>
            <Treatments />
          </b-collapse> -->
        </div>
        <div class="col-12">
          <!-- Tratativas -->
          <div class="mt-5" v-b-toggle.collapse-2>
            <div v-if="userProfile.permissions.treatments.menu">
              <b-tabs content-class="mt-3">
                <b-tab :title="`${this.$t(
                  'answers.answersDetails.treatments.treatmentTabLabel',
                )}`" active>
                  <p>
                    <Treatments />
                  </p>
                </b-tab>
                <template>
                  <b-tab v-if="userProfile.permissions.treatments.emailresponse != false
                    " :title="`${this.$t(
                        'answers.answersDetails.treatments.answerTabLabel',
                      )}`" @click="
                      modalAnonymousResponse();
                    setViewedEmailReply();
                    ">
                    <TreatmentsReply />
                  </b-tab>
                </template>
                <b-tab title="REVISÃO" v-if="revisionMode.active && $route.query.revision">

                  <div class="row">
                    <div class="col-5">
                      <idx-card title="Status">
                        <p>
                          Status
                        </p>
                        <b-form-select v-model="revisionData.status" style="width: 100%;"
                          :options="revisionStatusOptions"
                            :disabled="oneAnswer.treatments.statusRevision && !revisionMode.isAdmin &&
                            (this.oneAnswer.treatments.statusRevision === 'Aprovado' ||
                            this.oneAnswer.treatments.statusRevision === 'Reprovado')"></b-form-select>
                      </idx-card>
                      <br><br>
                      <idx-card :title="revisionMode.isAdmin ? 'Motivo' : 'Pedido de revisao'">
                        <b-form-textarea v-model="revisionData.comment" placeholder="Digite aqui..." rows="3"
                        :disabled="oneAnswer.treatments.statusRevision && !revisionMode.isAdmin &&
                        (this.oneAnswer.treatments.statusRevision === 'Aprovado' || this.oneAnswer.treatments.statusRevision === 'Reprovado')" />

                        <br>

                        <b-list-group class="mb-2">
                          <b-list-group-item v-for="(item, index) in filesToUploadRevision" :key="item.name">
                            <font-awesome-icon style="color: #777777" :icon="['fas', 'paperclip']" />
                            {{ item.name.substring(0, 40) + '...' }}
                            <font-awesome-icon class="float-right" style="color: red" @click="removeFile(index)"
                              :icon="['fas', 'times-circle']" />
                          </b-list-group-item>
                        </b-list-group>
                        <div class="text-center" v-if="isLoadingUpload">
                          <b-spinner variant="primary" label=""></b-spinner>
                        </div>
                        <label style="
                      font-weight: bold;
                      font-size: 15px;
                      margin-bottom: 10px;
                    " for="selectFileUploadRevision" v-if="!isLoadingUpload">
                          {{ $t('uploads.attachFile') }}:
                        </label>

                        <hr style="margin-top: 3px" />
                        <b-form-file v-if="!isLoadingUpload"
                          multiple
                          :placeholder="$t('uploads.attachFile')"
                          :browse-text="$t('uploads.selectLabel')"
                          :drop-placeholder="$t('uploads.dropPlaceholder')"
                          id="selectFileUploadRevision"
                          ref="fileuploadrevision"
                          v-model="filesToUploadRevision"
                          :disabled="oneAnswer.treatments.statusRevision && !revisionMode.isAdmin &&
                          (this.oneAnswer.treatments.statusRevision === 'Aprovado' || this.oneAnswer.treatments.statusRevision === 'Reprovado')">

                        </b-form-file>

                      </idx-card>

                      <br>
                      <button
                        :disabled="oneAnswer.treatments.statusRevision && !revisionMode.isAdmin &&
                        (this.oneAnswer.treatments.statusRevision === 'Aprovado' || this.oneAnswer.treatments.statusRevision === 'Reprovado')"
                       class="btn btn-primary btn-block" @click="sendRevision()">Enviar</button>
                      <br><br>
                    </div>
                    <div class="col-7">
                      <idx-card-revision
                        title="Feed"
                        :showFilters="true"
                      >
                        <feed-item :items="costumerNotifications" />
                      </idx-card-revision>
                    </div>
                  </div>

                </b-tab>
              </b-tabs>
            </div>
          </div>
          <span @click="goBack" :title="`${this.$t('answers.answersDetails.treatments.back')}`" class="go-back">
            <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsPdf from 'jspdf';
import paginate from 'vuejs-paginate';
import Html2canvas from 'html2canvas';
import { mapActions, mapState } from 'vuex';
// import { mapActions } from 'vuex';
import { lightFormat } from 'date-fns';
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';
import GoBackButton from '@/components/atoms/goback-button';
import ActionData from './action-data';
import Treatments from './treatments';
import TreatmentsReply from './treatments-reply';
import idxCard from '@/components/molecules/idx-card';
import idxCardRevision from '@/components/molecules/idx-card-revision';
import FeedItem from '@/components/molecules/treatment-feed-item';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

export default {
  components: {
    ActionData,
    Treatments,
    GoBackButton,
    TreatmentsReply,
    paginate,
    idxCardRevision,
    idxCard,
    FeedItem,
  },

  data: () => ({
    isLoading: false,
    loading: true,
    userAuth: null,
    error: false,
    loadingPdf: false,
    modalResearch: false,
    filter: null,
    total: 10,
    totalAction: 10,
    page: 1,
    limit: 5,
    fields: [],
    fieldsAction: [],
    items: [],
    idBranch: null,
    idAction: null,
    allActions: null,
    pageAction: 1,
    filterAction: null,
    revisionMode: {
      active: true,
      isAdmin: false,
    },
    revisionStatusOptions: [],
    revisionData: {
      status: '',
      comment: '',
      files: [],
    },
    filesToUploadRevision: [],
    isLoadingUpload: false,
  }),

  watch: {
    filesToUploadRevision: async function watchFileToUpload(arrayFiles) {
      if (arrayFiles.length > 5) {
        swal({
          title: this.$t(
            'answers.answersDetails.treatments.swExceededQuantity.title',
          ),
          text: this.$t(
            'answers.answersDetails.treatments.swExceededQuantity.description',
          ),
          icon: 'error',
        });
        this.$refs.fileuploadrevision.reset();
      }
    },
  },

  computed: {
    ...mapFields('treatments', ['costumerNotifications', 'oneAnswer']),
    ...mapFields('alertRules', ['branchItems', 'loadingBranches']),
    ...mapFields('branches', ['ih1']),
    ...mapState('authentication', ['userProfile']),
    ...mapFields('companies', ['company']),

  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getCompany({
      id: this.userAuth.companyId,
      token: this.userAuth.token,
    });

    this.revisionMode.active = this.company.enableTreatmentRevision || false;
    this.revisionMode.isAdmin = (this.userProfile.type === 'admin' || this.userProfile.name === 'Fábrica') ? true : false;

    await this.getBranches();
    await this.getActions();

    this.fields = [
      {
        key: 'corporate_name',
        label: 'Filial',
      },
      {
        key: 'createdAt',
        label: 'Data de criação',
      },
      {
        key: 'options',
        label: 'Opções',
      },
    ];

    this.fieldsAction = [
      {
        key: 'name',
        label: 'Ação',
      },
      {
        key: 'createdAt',
        label: 'Data de criação',
      },
      {
        key: 'options',
        label: 'Opções',
      },
    ];

    try {
      await this.setOneAnswer({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        answerId: this.$route.params.id,
      });
    } catch (error) {
      swal({
        title: this.$t('answers.answersDetails.treatments.swAddError.title'),
        text: error.response.data.message,
        icon: 'error',
      });

      this.error = true;
    }

    if (this.revisionMode.active) {
      if (this.revisionMode.isAdmin) {
        this.revisionStatusOptions = [
          { value: 'Aprovado', text: 'Aprovado' },
          { value: 'Reprovado', text: 'Reprovado' },
          { value: 'Pendente', text: 'Pendente' },
        ]

        this.revisionData.status = 'Pendente';

      } else {
        this.revisionMode.isAdmin = false;
        this.revisionStatusOptions = [
          { value: 'Aguardando análise', text: 'Aguardando análise' },
        ]

        this.revisionData.status = 'Aguardando análise';
      }
    }
    this.loading = false;

    EventBus.$on('update-feed-revision', async (order, optionValue) => {
        await this.setCostumerNotifications({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        answerId: this.oneAnswer._id,
        order,
        optionValue
      });
    });
  },

  methods: {
    ...mapActions('treatments', [
      'setCostumerNotifications',
      'setOneAnswer',
      // 'oneAnswer',
    ]),
    ...mapActions('branches', ['getBranchesIH1']),
    ...mapActions('companies', ['getCompany']),


    async sendRevision() {

      if (this.revisionData.status) {

        try {

          if (this.filesToUploadRevision.length) {

            if (
              this.filesToUploadRevision.filter((item) => item.size > 10000000).length
            ) {
              window.console.log('muito grande');
              swal({
                title: this.$t(
                  'answers.answersDetails.treatments.swAddError.title',
                ),
                text: 'Um ou mais arquivos excedem o limite. O tamanho máximo permitido é 10Mb',
                icon: 'error',
              });
              this.$refs.fileuploadrevision.reset();
            } else {
              this.isLoadingUpload = true;

              // eslint-disable-next-line no-restricted-syntax
              for (const file of this.filesToUploadRevision) {
                const formData = new FormData();
                formData.append('file', file);
                // eslint-disable-next-line no-await-in-loop
                const link = await api.post(
                  'treatments/attachments',
                  formData,
                  {
                    headers: {
                      'x-access-token': this.userAuth.token,
                      'Content-Type': 'multipart/form-data',
                    },
                  },
                );
                this.revisionData.files.push(link.data);
              }

              this.isLoadingUpload = false;
            }

          }

          await api.put(`/treatments-revisions/${this.oneAnswer._id}`,
            {
              status: this.revisionData.status,
              comment: this.revisionData.comment,
              files: this.revisionData.files,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            })

          this.setCostumerNotifications({
            token: this.userAuth.token,
            companyId: this.userAuth.companyId,
            answerId: this.$route.params.id,
            order: 'latest'
          });

          this.filesToUploadRevision = [];
          this.revisionData = {
            status: '',
            comment: '',
            files: [],
          };

          swal({
            title: 'Sucesso',
            icon: 'success',
          });



        } catch (error) {
          console.error(error);
          swal({
            title: 'Erro!',
          })
        }

      } else {
        swal({
          title: 'Por favor, selecione um status',
          icon: 'warning',
        })
      }
    },

    removeFile(index) {
      this.filesToUploadRevision.splice(index, 1);
    },

    async getActions() {
      const response = await api.get(
        `/treatments/all-actions/${this.oneAnswer.metric}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            page: this.pageAction,
            limit: 5,
            filter: this.filterAction,
          },
        },
      );

      this.totalAction = response.data.total;

      this.allActions = response.data;
    },

    async setViewedEmailReply() {
      await api.put(
        `/email-treatments/${this.$route.params.id}`,
        {
          viewedEmail: true,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },
    deleteAnswer() {
      swal({
        title: this.$t('answers.deleteAnswer.title'),
        text: this.$t('answers.deleteAnswer.description'),
        icon: 'warning',
        buttons: [this.$t('answers.cancel'), this.$t('answers.remove')],
        dangerMode: true,
      }).then((deleted) => {
        if (deleted) {
          swal(this.$t('answers.removeSuccess'), {
            icon: 'success',
          });
          this.disableAnswer({
            token: this.userAuth.token,
            companyId: this.userAuth.companyId,
            data: {
              answerId: this.$route.params.id,
            },
          });
        }
      });
    },

    async handleFilter() {
      this.page = 1;
      await this.getBranches();
    },

    async handleFilterAction() {
      this.pageAction = 1;
      await this.getActions();
    },

    async cleanFilter(value) {
      if (value === 'action') {
        this.filterAction = null;
        await this.getActions();
      } else {
        this.filter = null;
        await this.getBranches();
      }
    },

    formatDate(myDate) {
      const day = lightFormat(new Date(myDate), 'dd/MM/yyyy');
      const time = lightFormat(new Date(myDate), 'HH:mm');
      return `${day} às ${time}`;
    },

    async getBranches() {
      this.loadingBranches = true;
      await this.getBranchesIH1({
        companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
        token: JSON.parse(localStorage.getItem('_indecx')).token,
        page: this.page,
        limit: 5,
        filter: this.filter,
      });
      this.total = this.branchItems.total;
      this.loadingBranches = false;
    },

    exportPdfTreatments() {
      setTimeout(() => {
        this.loadingPdf = !false;
        const data = document.getElementById('main-treatments');

        Html2canvas(data, {
          allowTaint: true,
          scale: 2,
        }).then((canvas) => {
          if (canvas.height < 1730) {
            const imgWidth = 290;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const imageData = canvas.toDataURL('image/png');
            const pdf = new JsPdf('l', 'mm', 'a4', true);
            const x = 5;
            const y = 8;

            pdf.addImage(
              imageData,
              'PNG',
              x,
              y,
              imgWidth,
              imgHeight,
              '',
              'FAST',
            );
            pdf.setFontSize(10.0);
            pdf.setTextColor(115, 115, 115);
            pdf.text('DADOS DA AÇÃO', 25, 20);
            pdf.save('detalhes-acao.pdf');
          } else {
            const contentWidth = canvas.width;
            const contentHeight = canvas.height;
            const pageData = canvas.toDataURL('image/jpeg', 1.0);
            const pdfX = ((contentWidth - 10) / 2) * 0.75;
            const pdfY = (contentHeight + 500) * 0.75;
            const imgX = pdfX;
            const imgY = (contentHeight / 2) * 0.75;
            const pdf = new JsPdf('', 'pt', [pdfX, pdfY], true);

            pdf.addImage(pageData, 'jpeg', 0, 20, imgX, imgY, '', 'FAST');
            pdf.setFontSize(10.0);
            pdf.setTextColor(115, 115, 115);
            pdf.text('DADOS DA AÇÃO', 25, 20);
            pdf.save('detalhes-acao.pdf');
          }
          this.loadingPdf = !true;
        });
      }, 100);
    },

    async transferAction() {
      try {
        await api.patch(
          `/answer-actions/${this.$route.params.id}`,
          {
            newActionId: this.idAction,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        await this.setOneAnswer({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.$route.params.id,
        });

        this.setCostumerNotifications({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.$route.params.id,
        });

        swal({
          title: 'Transferência realizada com sucesso!',
          icon: 'info',
          buttons: ['Cancelar', 'Ok'],
        }).then(async (yes) => {
          if (yes) {
            try {
              location.reload();
            } catch (error) {
              swal({
                title: 'Erro em Transferência',
                text:
                  'Ocorreu um erro na transferência. Por favor tente novamente em instantes',
                icon: 'error',
              });
            }
          }
        });

        // swal({
        //   title: this.$t('answers.answersDetails.transferSuccess'),
        //   icon: 'success',
        // });
        // this.setCostumerNotifications({
        //   token: this.userAuth.token,
        //   companyId: this.userAuth.companyId,
        //   answerId: this.$route.params.id,
        // });
      } catch (error) {
        swal({
          title: this.$t('answers.answersDetails.transferError'),
          text: this.$t('answers.answersDetails.transferErrorMessage'),
          icon: 'error',
        });
      }
    },

    async transfer() {
      try {
        await api.patch(
          `/answer/${this.$route.params.id}`,
          {
            ih1: this.idBranch,
            changeInvite: true,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        await this.setOneAnswer({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.$route.params.id,
        });

        swal({
          title: this.$t('answers.answersDetails.transferSuccess'),
          icon: 'success',
        });
        this.setCostumerNotifications({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.$route.params.id,
        });
      } catch (error) {
        swal({
          title: this.$t('answers.answersDetails.transferError'),
          text: this.$t('answers.answersDetails.transferErrorMessage'),
          icon: 'error',
        });
      }
    },

    async transferMercedez() {
      if (this.oneAnswer.ih1 === '60917263ffbb3a4b24d9dff6') {
        swal({
          title: 'Transferência já realizada',
          text: 'Essa resposta já foi transferida para a conta de fábrica',
          icon: 'error',
        });
        return;
      }
      swal({
        title: 'Transferência de Resposta',
        text:
          'Tem certeza que deseja transferir essa resposta para a conta de fábrica?',
        icon: 'warning',
        buttons: ['Cancelar', 'Ok'],
      }).then(async (yes) => {
        if (yes) {
          try {
            await api.patch(
              `/answer/${this.$route.params.id}`,
              {
                ih1: '60917263ffbb3a4b24d9dff6',
              },
              {
                headers: {
                  'x-access-token': this.userAuth.token,
                },
              },
            );
            swal({
              title: 'Transferência realizada com sucesso!',
              icon: 'success',
            });
            this.setCostumerNotifications({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              answerId: this.$route.params.id,
            });
            // location.reload();
          } catch (error) {
            swal({
              title: 'Erro em Transferência',
              text:
                'Ocorreu um erro na transferência. Por favor tente novamente em instantes',
              icon: 'error',
            });
          }
        }
      });
    },

    modalAnonymousResponse() {
      if (this.oneAnswer.anonymousResponse === true) {
        swal({
          title: 'Está é uma resposta anonima, você não poderá responde-la!',
          icon: 'success',
        });
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper {
  padding: 8px;
}

.collapsed>.when-opened,
:not(.collapsed)>.when-closed {
  display: none;
}

.wrapp {
  background-color: $white;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid $gray-light;
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 6px;
  padding-right: 12px;
  color: $gray;
}

.wrapp h2 {
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 100;
  color: $gray;
}

.menu-icons {
  float: left;
  min-width: 25px;
  color: $primary;
}

.export-pdf-treatments,
.transfer-treatments {
  // margin-left: 96%;
  margin-top: 20px;
  background-color: #fff;
  border-color: #fff;
  font-size: 25px;
  color: #4ce595;
  margin-bottom: 20px;

  :hover {
    color: $gray;
  }
}

.divButton {
  display: flex;
  margin-left: 93%;
}

.wrapp h3 {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 100;
}

.pagination-area-edit-rule>>>a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-edit-rule .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-edit-rule a {
  outline: none;
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.go-back {
  color: $primary;
  font-size: 35px;
  cursor: pointer;

  :hover {
    color: #2be081;
  }
}

.btn-transfer {
  color: #4ce595;
  font-size: 25px;
}

.btn-research {
  padding: 0;
  background: #fff;
  border: 0;

  :hover {
    background: #f0f0f0;
  }
}

.btn-research:active {
  background: #4ce595;
}
</style>
<style>
#ddd .dropdown-toggle {
  background: white;
  border: none;
  color: #4ce595;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/treatments/treatment-details/index.vue